// src/components/Loader/PageLoader.jsx
export default function PageLoader({ label = "Loading…" }) {
  return (
    <div className="page-loader" role="status" aria-live="polite">
      <div className="page-loader-spinner" />
      <p className="page-loader-label">{label}</p>
    </div>
  );
}
